import { makeStyles, Typography } from '@material-ui/core';
import { useContext } from 'react';
import { LanguageContext } from '../../../contexts/LanguageContext/languageContext';

export interface AssetAttribute {
  key: string;
  title: string;
  color?: string;
  isVisible?: boolean;
}

export type Asset = Record<string, string>;

interface AssetAttributeElementProps {
  attribute: AssetAttribute;
  asset: Asset;
}

const AssetAttributeElement = (props: AssetAttributeElementProps) => {
  const classes = useStyles();
  const { translate } = useContext(LanguageContext);
  const dataValue = props.asset[props.attribute.key];
  return props.attribute.isVisible === true ? (
    <div className={classes.container}>
      <Typography className={classes.value} component="div" style={{ color: props.attribute.color }}>
        <p className={classes.para}>
          <span className={classes.label}>{translate(props.attribute.title)}:</span>
          <span style={!dataValue && props.attribute.color === '#1D1D1F' ? { color: '#AAAAAA' } : undefined}>
            {dataValue ? dataValue : '(None)'}
          </span>
        </p>
      </Typography>
    </div>
  ) : null;
};

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    minHeight: 16,
    marginBottom: 3,
  },
  label: {
    fontWeight: 'normal',
    fontSize: 14,
    marginRight: 2,
    fontFamily: 'Roboto',
    whiteSpace: 'nowrap',
    '& div': {
      lineHeight: '13px',
    },
  },
  value: {
    wordWrap: 'break-word',
    lineHeight: '100%',
    fontSize: 14,
    fontWeight: 300,
  },
  para: {
    margin: 0,
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'Roboto',
    wordBreak: 'break-all',
  },
}));

export default AssetAttributeElement;
